import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Fields from "@components/fields";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import generalSettings from "@apis/generalSettings";
import { toast } from "react-toastify";

const AdminQR = () => {
  const [qrItem, setQrItem] = useState<any>(null);
  const [initialValues, setInitialValues] = useState({
    adminQr: null as any,
  });
  const [loading, setLoading] = useState(false);

  const fetchQR = async () => {
    try {
      const res = await generalSettings.getByKey({
        state: "admin-qr",
        id: "admin-qr",
        showErr: false,
      });
      if (res) {
        setQrItem(res);
        setInitialValues({
          adminQr: res.file,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchQR();
  }, []);

  const handleUpload = async (values: typeof initialValues) => {
    const file = values.adminQr;
    if (!file || (!file.rawFile && !qrItem))
      return toast.error("Please select a file first");

    if (!file.rawFile && qrItem) {
      return toast.info("No changes to upload");
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file.rawFile);
    formData.append("key", "admin-qr");
    formData.append("group", "general-settings");
    formData.append("value", "Admin QR Code");

    try {
      if (qrItem?.id) {
        await generalSettings.update({
          state: "admin-qr",
          id: qrItem.id,
          data: formData,
        });
      } else {
        await generalSettings.create({
          state: "admin-qr",
          data: formData,
        });
      }
      toast.success("Admin QR updated successfully");
      fetchQR();
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload Admin QR");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: "100%", maxWidth: "400px" }}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={handleUpload}
      >
        {({ values, submitForm }) => (
          <Form>
            <CardHeader title="Admin QR Code" />
            <Wrapper>
              <Fields.Upload name="adminQr" height={250} useRawFile={true} />
              <div style={{ marginTop: "1rem", textAlign: "right" }}>
                <Button
                  title={qrItem ? "Update QR" : "Upload QR"}
                  loading={loading}
                  type="button"
                  onClick={() => submitForm()}
                />
              </div>
            </Wrapper>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminQR;
